export default {
  data () {
    return {
      projectProgressNodeMap: {
        'project_init': {
          icon: 'el-icon-s-order',
          subtitle: '系统自动记录',
          editable: false,
          allow_multi_fill: false,
          nodeViewComponent: null,
          nodeDialogComponent: null,
        },
        'upload_customer_list': {
          icon: 'el-icon-s-custom',
          subtitle: '填写完成后触发地址清洗通知',
          editable: true,
          allow_multi_fill: true,
          nodeViewComponent: 'UploadCustomerListView',
          nodeDialogComponent: 'UploadCustomerListDialog',
        },
        'project_cost_confirm': {
          icon: 'el-icon-bank-card',
          subtitle: '需领导确认后方可继续后续节点',
          editable: true,
          auditable: true,
          allow_multi_fill: true,
          nodeViewComponent: 'ProjectCostConfirmView',
          nodeDialogComponent: 'ProjectCostConfirmDialog',
          nodeAuditComponent: 'ProjectCostAuditDialog',
        },
        'kickoff_meeting': {
          icon: 'el-icon-s-flag',
          subtitle: '项目负责人填写',
          editable: true,
          allow_multi_fill: false,
          nodeViewComponent: 'KickoffMeetingView',
          nodeDialogComponent: 'KickoffMeetingDialog',
        },
        'upload_cleaned_files': {
          icon: 'el-icon-refresh',
          subtitle: '清洗人员上传附件',
          editable: true,
          allow_multi_fill: true,
          nodeViewComponent: 'UploadCleanedFilesView',
          nodeDialogComponent: 'UploadCleanedFilesDialog',
        },
        'task_online': {
          icon: 'el-icon-upload2',
          subtitle: '系统自动记录',
          editable: false,
          allow_multi_fill: false,
          nodeViewComponent: 'TaskOnlineView',
          nodeDialogComponent: null,
        },
        'progress_share_meeting': {
          icon: 'el-icon-share',
          subtitle: '项目负责人填写',
          editable: true,
          allow_multi_fill: true,
          nodeViewComponent: 'ProgressShareMeetingView',
          nodeDialogComponent: 'ProgressShareMeetingDialog',
        },
        'task_offline': {
          icon: 'el-icon-download',
          subtitle: '系统自动记录',
          editable: false,
          allow_multi_fill: false,
          nodeViewComponent: 'TaskOfflineView',
          nodeDialogComponent: null,
        },
        'upload_project_report': {
          icon: 'el-icon-document-checked',
          name: '结算交付',
          subtitle: '上传邮件或截图',
          editable: true,
          allow_multi_fill: true,
          nodeViewComponent: 'UploadProjectReportView',
          nodeDialogComponent: 'UploadProjectReportDialog',
        },
        'review_meeting': {
          icon: 'el-icon-s-data',
          subtitle: '项目负责人填写',
          editable: true,
          allow_multi_fill: true,
          nodeViewComponent: 'ReviewMeetingView',
          nodeDialogComponent: 'ReviewMeetingDialog',
        },
        'project_issue_invoice': {
          icon: 'el-icon-tickets',
          subtitle: '系统自动记录',
          editable: false,
          allow_multi_fill: false,
          nodeViewComponent: 'ProjectIssueInvoiceView',
          nodeDialogComponent: null,
        },
        'payment_receive': {
          icon: 'el-icon-money',
          subtitle: '系统自动记录',
          editable: false,
          allow_multi_fill: false,
          nodeViewComponent: 'PaymentReceiveView',
          nodeDialogComponent: null,
        },
        'bo_header_score': {
          icon: 'el-icon-star-off',
          name: 'BO评分',
          subtitle: '回款完成后可评价,由项目的BO审核人填写',
          editable: true,
          allow_multi_fill: false,
          nodeViewComponent: 'BoHeadEvaluationView',
          nodeDialogComponent: 'BoHeadEvaluationDialog',
        },
        'first_audit_score': {
          icon: 'el-icon-star-on',
          name: '一级审核评分',
          subtitle: 'BO评分后填写,由Ken填写(选填)',
          editable: true,
          allow_multi_fill: false,
          nodeViewComponent: 'BoHeadEvaluationView',
          nodeDialogComponent: 'FirstEvaluationDialog',
        },
        'second_audit_score': {
          icon: 'el-icon-star-on',
          name: '二级审核评分',
          subtitle: '一级审核评分后填写,由Irene填写(选填)',
          editable: true,
          allow_multi_fill: false,
          nodeViewComponent: 'BoHeadEvaluationView',
          nodeDialogComponent: 'SecondEvaluationDialog',
        },
      },
      dateTimeLteTodayOptions: {
        disabledDate: function (time) {
          return time.getTime() > Date.now()
        },
      },
      dateTimeGteTodayOptions: {
        disabledDate: function (time) {
          return time.getTime() < new Date().setHours(0, 0, 0, 0)
        },
      },
    }
  },
  methods: {
    // 判断当前登录账号是否为 数据清洗专员
    isDataCleanserAccount () {
      return !filter.superPermission() && filter.hasPermission(14002)
    },
    handleProjectProgressSteps (progress) {
      return progress.map((node) => {
        // 预处理日期
        const dateParts = node.time_show_in_table ? node.time_show_in_table.split(' ') : []
        return {
          ...node,
          ...this.projectProgressNodeMap[node.key],
          tableDateStr: dateParts[0] || '',
          tableTimeStr: dateParts[1] || '',
        }
      })
    },
    // 封装 loading 包装器
    async withLoading (asyncFn, text = '加载中...') {
      const loading = this.$loading({
        lock: true,
        text,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      try {
        return await asyncFn()
      } finally {
        loading.close()
      }
    },
    // 弹窗使用到的函数
    progressDialogAfterSubmitSuccess (data) {
      this.dialogVisible = false
      // if (this.projectNode.allowMultiFillData) {
      //   this.$emit('update:projectNode', data)
      //   this.initAttr(data)
      // } else {
      //   this.progressAfterDialogClosed()
      // }
    },
    // 弹窗关闭以后运行这个函数
    progressAfterDialogClosed () {
      this.$emit('refreshDetail')
    },
    async downloadProgressAttachFile (file) {
      if (!file.url) {
        this.$message.warning('文件地址为空')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '准备下载...',
        spinner: 'el-icon-download',
        customClass: 'download-progress-loading',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      // 注入进度条
      const spinnerEl = loading.$el.querySelector('.el-loading-spinner')
      if (spinnerEl) {
        spinnerEl.querySelector('i').style.cssText = 'font-size: 40px; color: #409EFF; margin-bottom: 8px; display: inline-block;'
        const barWrap = document.createElement('div')
        barWrap.style.cssText = 'width: 260px; margin: 12px auto 0;'
        barWrap.innerHTML = '<div style="width:100%;height:6px;background:rgba(255,255,255,0.15);border-radius:3px;overflow:hidden;">' +
          '<div style="width:0;height:100%;background:linear-gradient(90deg,#409EFF,#67C23A);border-radius:3px;transition:width 0.2s ease;"></div></div>'
        spinnerEl.appendChild(barWrap)
      }
      const barFill = loading.$el.querySelector('.el-loading-spinner div div div')
      try {
        const response = await fetch(file.url)
        if (!response.ok) throw new Error('网络请求失败')

        const contentLength = +response.headers.get('Content-Length')
        const reader = response.body.getReader()
        const chunks = []
        let receivedLength = 0

        while (true) {
          const {done, value} = await reader.read()
          if (done) break
          chunks.push(value)
          receivedLength += value.length
          if (contentLength) {
            const percent = Math.round((receivedLength / contentLength) * 100)
            if (barFill) barFill.style.width = percent + '%'
            loading.text = `正在下载 ${percent}%`
          } else {
            loading.text = `正在下载 ${(receivedLength / 1024 / 1024).toFixed(1)}MB`
          }
        }

        const blob = new Blob(chunks)
        const blobUrl = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = blobUrl
        a.download = file.name || 'download'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(blobUrl)
      } catch (err) {
        console.error(err)
        window.open(file.url, '_blank')
      } finally {
        loading.close()
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/project/project.mixins.js